module.exports = __webpack_public_path__ + "img/icon-white-49.723b9869.svg";